import { takeLatest } from 'redux-saga/effects'
import { FETCH_LOCATION_UNITS_REQUEST } from './types'
import { fetchLocationUnitsSaga } from './sagas'

export function* locationUnitWatcherSagas() {
  yield takeLatest(FETCH_LOCATION_UNITS_REQUEST, fetchLocationUnitsSaga)
}
